import React from "react";

const SupportCards = (props) => {
  const timeManager = (time) => {
    if (time) {
      const splittedTime = time
        .split("T")[1]
        .split(".")[0]
        .split(":");
      return `${splittedTime[0]}:${splittedTime[1]}`;
    }
  };
  return (
    <>
      {props.supportTickets
        ? props.supportTickets.map((el) => {
            return (
              <div
                className="d-flex flex-column w-100 bg-white p-5 shadow-sm my-4 container"
                style={{ border: "1px solid lightgray", borderRadius: 12 }}
              >
                <div className="d-md-flex d-block ">
                  <div
                    className="d-flex w-50 my-3"
                    style={{ gap: 5, paddingRight: "5%", whiteSpace: "nowrap" }}
                  >
                    {" "}
                    <h5 style={{ opacity: "0.8" }}>
                      <b>عنوان:</b>
                    </h5>
                    <h6 style={{ whiteSpace: "nowrap", marginRight: 5 }}>
                      {el.SupportItem ? el.SupportItem.title : null}
                    </h6>
                  </div>
                  <div
                    className="d-flex w-50 my-3"
                    style={{ gap: 5, paddingRight: "5%", whiteSpace: "nowrap" }}
                  >
                    {" "}
                    <h5 style={{ opacity: "0.8" }}>
                      <b>زمان ثبت:</b>
                    </h5>
                    <h6 style={{ whiteSpace: "nowrap", marginRight: 5 }}>
                      {timeManager(el.createdAt)}
                    </h6>
                  </div>
                </div>
                <div
                  className="line w-100 mx-auto"
                  style={{ marginBlock: "2%", borderBottom: "1px solid gray" }}
                ></div>
                <div className="d-md-flex d-block ">
                  <div
                    className="d-flex w-50 my-3"
                    style={{ gap: 5, paddingRight: "5%", whiteSpace: "nowrap" }}
                  >
                    {" "}
                    <h5 style={{ opacity: "0.8" }}>
                      <b>توضیحات:</b>
                    </h5>
                    <h6 style={{ whiteSpace: "nowrap", marginRight: 5 }}>
                      {el.description}
                    </h6>
                  </div>
                  <div
                    className="d-flex w-50 my-3"
                    style={{ gap: 5, paddingRight: "5%", whiteSpace: "nowrap" }}
                  >
                    {" "}
                    <h5 style={{ opacity: "0.8" }}>
                      <b>کد بلیط:</b>
                    </h5>
                    <h6 style={{ whiteSpace: "nowrap", marginRight: 5 }}>
                      ۱۲۳۳۲۱۱۲۳
                    </h6>
                  </div>
                </div>
              </div>
            );
          })
        : null}
    </>
  );
};

export default SupportCards;
